<template>
  <div>
    <!-- 电脑端 -->
    <div class="main login-pc">
      <div class="dowebok" id="dowebok">
        <div class="form-container sign-up-container">
          <div class="login-logo">
            <img src="../../assets/img/logo.png" alt="" srcset="" />
          </div>
          <form>
            <h1 class="h3">注册</h1>
            <input
              type="text"
              v-model="dataForm.userName"
              placeholder="用户名"
            />
            <input type="text" v-model="dataForm.mobile" placeholder="手机号" />
            <input
              type="password"
              v-model="dataForm.password"
              placeholder="密码"
              @keydown.enter="registeredlogin"
            />
            <a @click="registeredlogin">注册</a>
          </form>
        </div>
        <div class="form-container sign-in-container">
          <div class="login-logo">
            <img src="../../assets/img/logo.png" alt="" srcset="" />
          </div>
          <form>
            <h1 class="h3" style="margin-bottom: 22px">我有账号，立即登录！</h1>
            <input
              type="text"
              v-model="loginForm.userName"
              placeholder="用户名"
            />
            <input
              type="password"
              v-model="loginForm.password"
              placeholder="密码"
              @keydown.enter="onlogin"
            />
            <a @click="onlogin">登录</a>
          </form>
        </div>
        <div class="overlay-container">
          <div class="overlay">
            <div class="overlay-panel overlay-left">
              <h1>已有帐号？</h1>
              <p>使用账号，立即登录！</p>
              <a class="ghost" id="signIn">登录</a>
            </div>
            <div class="overlay-panel overlay-right">
              <h1>没有帐号？</h1>
              <p>立即注册加入我们，和我们一起进入文艺的世界</p>
              <a class="ghost" id="signUp">注册</a>
            </div>
          </div>
        </div>
      </div>
      <div id="footer" class="container-fluid">
        <div style="margin-right: 40px">© 2021-2026 对外演出节目库</div>
        <div>
          <a
            href="https://beian.miit.gov.cn/"
            target="_target"
            style="color: #777777; font-weight: normal"
            >京ICP备18060883号-2</a
          >
        </div>
      </div>
    </div>

    <!-- 手机端 -->
    <div class="login-mobile">
      <div class="Logo">
        <img src="../../assets/img/logo.png" alt="" srcset="" />
      </div>


      <!-- 登录 -->
      <div class="mobile-form">
        <div class="mobile-username">
          <input
            type="text"
            v-model="loginForm.userName"
            placeholder="输入用户名"
          />
        </div>
        <div class="mobile-password">
          <input
            type="password"
            v-model="loginForm.password"
            placeholder="输入密码"
            @keydown.enter="onlogin"
          />
        </div>
        <div class="mobile-login"  @click="onlogin">
          <a>登录</a>
        </div>
        <div class="gozhuce" @click="goZhuce">
          <span>没有账号？</span>
          立即注册加入我们<br />和我们一起进入文艺的世界
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
var lockReconnect = false; //避免ws重复连接

import { fLogin, registerUser } from "../../api/api";
export default {
  data() {
    return {
      loginForm: {
        userName: "",
        password: "",
      },
      dataForm: {
        userName: null,
        password: null,
        mobile: null,
        code: "",
      },
      change: true,
      smsmobile: "13839806091",
      smscode: "123456",
      // 表单验证规则
      dataRule: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
      // 倒计时现实隐藏
      buttonName: "发送短信",
      isDisabled: false,
      time: 10,
    };
  },
  created() {},
  mounted() {
    var signUpButton = document.getElementById("signUp");
    var signInButton = document.getElementById("signIn");
    var container = document.getElementById("dowebok");
    signUpButton.addEventListener("click", function () {
      container.classList.add("right-panel-active");
    });

    signInButton.addEventListener("click", function () {
      container.classList.remove("right-panel-active");
    });
  },
  methods: {
    // 登陆
    onlogin(event) {
      event.stopPropagation();
      if (this.loginForm.userName && this.loginForm.password) {
        // 用户端登录
        fLogin({
          ...this.loginForm,
          password: this.$md5(this.loginForm.password),
        }).then(({ data }) => {
          console.log(data);
          if ((data && data.code == 0) || data.code == 200) {
            this.$message.success("登录" + data.message);
            this.$cookie.set("Token", data.t.token);
            localStorage.setItem("id", data.t.use.id);
            localStorage.setItem("name", data.t.use.name);
            this.$router.push({ name: "home", query: { SearchVal: "" } });
            this.startWs(data.t.use.id);
          }
        });
      } else {
        this.$message.warning("请填写用户名和密码");
      }
    },

    // soket
    startWs(userId) {
      try {
        if ("WebSocket" in window) {
          this.$websoket(userId);
        }
        this.initEventHandle(userId);
      } catch (e) {
        console.log(45);
        this.reconnect(this.path);
        console.log(e);
      }
    },

    initEventHandle(userId) {
      let that = this;
      this.$websoket(userId).onclose = function (e) {
        if(Vue.cookie.get('Token')){
          
          that.reconnect();
        }
        console.log("llws连接关闭!" + new Date().toLocaleString()+ e.code + ' ' + e.reason + ' ' + e.wasClean);
      };
      this.$websoket(userId).onerror = function () {
        if(Vue.cookie.get('Token')){
          
          that.reconnect();
        }
        console.log("llws连接错误!");
      };
      this.$websoket(userId).onopen = function () {
        console.log("onopen!")
        if(Vue.cookie.get('Token')){     
          heartCheck.reset().start(that.$websoket(userId)); //心跳检测重置
        }
        console.log("llws连接成功!" + new Date().toLocaleString());
      };
      this.$websoket(userId).onmessage = function (event) {
        console.log("onmessage!")
        //如果获取到消息，心跳检测重置
        if(Vue.cookie.get('Token')){     
          heartCheck.reset().start(that.$websoket(userId)); //心跳检测重置
        }
        console.log("llws收到消息啦:" + event.data);
        if (event.data != "pong") {
          let data = JSON.parse(event.data);
        }
      };
    },

    reconnect(url) {
      if (lockReconnect) return;
      lockReconnect = true;
      let that = this;
      setTimeout(function () {
        //没连接上会一直重连，设置延迟避免请求过多
        that.startWs(localStorage.getItem('id'));
        lockReconnect = false;
      }, 2000);
    },

    // 注册
    registeredlogin(event) {
      if (
        this.dataForm.userName &&
        this.dataForm.password &&
        this.dataForm.mobile
      ) {
        // 调用注册
        registerUser({
          ...this.dataForm,
          password: this.$md5(this.dataForm.password),
        }).then(({ data }) => {
          console.log(data);
          if ((data && data.code == 0) || data.code == 200) {
            this.$message({
              message: data.message,
              type: "success",
            });
            let dataForm = {
              userName: "",
              password: "",
              mobile: "",
            };
            this.dataForm = dataForm;
            $("#dowebok").removeClass("right-panel-active");
          }
        });
      } else {
        this.$message.warning("请填写完整注册信息");
      }
    },
    // 去注册
    goZhuce() {
      this.$router.push({
        name: 'registr'
      })
    }
  },
};
var heartCheck = {
    timeout: 40000,        //1分钟发一次心跳
    timeoutObj: null,
    serverTimeoutObj: null,
    reset: function(){
        clearTimeout(this.timeoutObj);
        clearTimeout(this.serverTimeoutObj);
        return this;
    },
    start: function(ws){
        var self = this;
        this.timeoutObj = setTimeout(function(){
            //这里发送一个心跳，后端收到后，返回一个心跳消息，
            //onmessage拿到返回的心跳就说明连接正常
            ws.send("ping");
            console.log("ping!")
            self.serverTimeoutObj = setTimeout(function(){//如果超过一定时间还没重置，说明后端主动断开了
                ws.close();     //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
            }, self.timeout)
        }, this.timeout)
    }
}
</script>
<style>
#footer {
  width: 100%;
  height: 36px;
  position: fixed;
  bottom: 0;
  left: 0;
  color: #777777;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}

#footer div {
  font-size: 16px;
  color: #777777;
}
.copyrights {
  text-indent: -9999px;
  height: 0;
  line-height: 0;
  font-size: 0;
  overflow: hidden;
}
h1,
p,
a {
  font-family: 宋体;
  font-weight: 700;
}
h1 {
  font-size: 30px;
}
p {
  font-size: 18px;
}
.dowebok {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  position: relative;
  overflow: hidden;
  width: 58%;
  max-width: 100%;
  margin: 10% auto;
  min-height: 480px;
}

.form-container form {
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 0 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.social-container {
  margin: 20px 0;
}

.social-container a {
  border: 1px solid #ddd;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
  height: 40px;
  width: 40px;
}

.login-logo {
  width: 45%;
  margin: 2% 0 0 3%;
  position: absolute;
}
.login-logo img {
  width: 100%;
}

.social-container a:hover {
  background-color: #eee;
}

.form-container input {
  background: #eee;
  border: none;
  padding: 12px 15px;
  margin: 8px 0;
  font-size: 18px;
  width: 100%;
  outline: none;
}

.dowebok a,
.dowebok button {
  border-radius: 20px;
  border: 1px solid #ff4b2b;
  background: #ff4b2b;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
  cursor: pointer;
}

a:active {
  transform: scale(0.95);
}

a:focus {
  outline: none;
}

a.ghost {
  background: transparent;
  border-color: #fff;
}

.form-container {
  position: absolute;
  top: 0;
  height: 100%;
  transition: all 0.6s ease-in-out;
}

.sign-in-container {
  left: 0;
  width: 50%;
  z-index: 2;
}

.sign-up-container {
  left: 0;
  width: 50%;
  z-index: 1;
  opacity: 0;
}

.overlay-container {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
  z-index: 100;
}

.overlay {
  background: #ff416c;
  background: linear-gradient(to right, #ff4b2b, #ff416c) no-repeat 0 0 / cover;
  color: #fff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateY(0);
  transition: transform 0.6s ease-in-out;
}

.overlay-panel {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 50%;
  text-align: center;
  transform: translateY(0);
  transition: transform 0.6s ease-in-out;
}

.h3 {
  color: #504949;
  font-size: 28px;
}

.overlay-panel p {
  margin: 20px 0 30px 0;
}

.overlay-right {
  right: 0;
  transform: translateY(0);
}

.overlay-left {
  transform: translateY(-20%);
}

/* Move signin to right */
.dowebok.right-panel-active .sign-in-container {
  transform: translateY(100%);
}

/* Move overlay to left */
.dowebok.right-panel-active .overlay-container {
  transform: translateX(-100%);
}

/* Bring signup over signin */
.dowebok.right-panel-active .sign-up-container {
  transform: translateX(100%);
  opacity: 1;
  z-index: 5;
}

/* Move overlay back to right */
.dowebok.right-panel-active .overlay {
  transform: translateX(50%);
}

/* Bring back the text to center */
.dowebok.right-panel-active .overlay-left {
  transform: translateY(0);
}

/* Same effect for right */
.dowebok.right-panel-active .overlay-right {
  transform: translateY(20%);
}

@media screen and (min-width: 805px) and (max-width: 1366px) {
  .dowebok {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    position: relative;
    overflow: hidden;
    width: 58%;
    max-width: 100%;
    margin: 68px auto 0;
    min-height: 380px;
  }

  .h3 {
    font-size: 18px;
    color: #504949;
  }
}

@media screen and (min-width: 1366px) and (max-width: 1470px) {
  h1 {
    font-size: 28px;
  }
  p {
    font-size: 16px;
  }
}

/* 平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .dowebok {
    min-height: 380px;
  }

  h1 {
    font-size: 18px;
  }
  p {
    font-size: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/common/login.vue